import type { Theme } from '@mui/material';

export const styles = {
  tableHeadCell: (theme: Theme) => ({
    color: theme.colors.neutral[400],
    border: 'none',
    pb: 2,
  }),
};
